import React from 'react';

const MessageInput = ({children}) => (
    <div style={{
        marginBottom: '24px',
        marginTop: '8px',
    }}>
        {children}
    </div>
);

export default MessageInput;